import timezoneAction from "./timezone/timezoneAction";
import userAction from "./user/userAction";

const actionTypes = {
  timezoneAction,
  userAction,
};

export default actionTypes;
